export const FIRM_LEVEL_FOLDERS_QUERY_KEY = 'firm-level-folders';
export const FIRM_LEVEL_SUMMARY_QUERY_KEY = 'firm-level-summary';
